export default __webpack_public_path__ + "static/summer_containers15-a22e2208d7666234eaffa96fc214cc7a.webp";